export const isAuthenticated = (state) => {
  if (state.loginUserToken != '') {
    return true;
  } else {
    return false;
  }
}

export const isOTPVerified = (state) => {
  return !!state.user.otp_verified;
}

export const isUsernameVerified = (state) => {
  return !!state.user.username_verified;
}

export const isEmailVerified = (state) => {
  return state.user.email_verified_at != null ? true : false;
}

export const getUser = (state) => {
  return state.user;
}

export const getUsername = (state) => {
  return state.user.username;
}

export const getLoginUserToken = (state) => {
  return state.loginUserToken;
}

export const getCustomerQuotation = (state) => {
  return state.customerQuotation;
}

export const getQuotationPayment = (state) => {
  return state.tempQuotationPayment
}

export const getSessionResponse = (state) => {
  return state.sessionResponseData
}

export const getPrePaymentData = (state) => {
  return state.prePaymentData
}

export const getSignupRedirect = (state) => {
  return state.signupRedirect
}



// WEBPACK FOOTER //
// ./src/store/modules/getters.js